// extracted by mini-css-extract-plugin
export default {"cell":"SettingsCell_cell__CBCfc"};